import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-bank-correspondent',
  templateUrl: './bank-correspondent.component.html',
  styleUrls: ['./bank-correspondent.component.css'],
})
export class BankCorrespondentComponent implements OnInit {
  public convenioBancolombia: string;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit() {
    this.convenioBancolombia = this.data.convenioBancolombia.value;
  }

  public closedModal() {
    this.dialog.closeAll();
  }
}
